import { render, staticRenderFns } from "./FactorBlock.vue?vue&type=template&id=a25ce3fa&scoped=true"
import script from "./FactorBlock.vue?vue&type=script&lang=ts"
export * from "./FactorBlock.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a25ce3fa",
  null
  
)

export default component.exports